"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 17,
    height: 16
  }, props), __jsx("g", {
    fill: "currentColor"
  }, __jsx("path", {
    d: "M37.778 28.23a2.02 2.02 0 00-2.02 2.02v3.092a2.62 2.62 0 01-2.618 2.616H6.86a2.62 2.62 0 01-2.618-2.616V30.25a2.02 2.02 0 00-4.04 0v3.092a6.667 6.667 0 006.658 6.666h26.28a6.667 6.667 0 006.667-6.666V30.25a2.02 2.02 0 00-2.029-2.02z"
  }), __jsx("path", {
    d: "M20 0a3.232 3.232 0 00-3.232 3.232v15.11a.417.417 0 01-.416.416H11.92a1.617 1.617 0 00-1.22 2.677l8.08 9.293a1.615 1.615 0 002.44 0l8.08-9.293a1.617 1.617 0 00-1.22-2.677h-4.432a.417.417 0 01-.416-.416V3.232A3.232 3.232 0 0020 0z"
  })));
}
var _default = exports.default = SvgComponent;